/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable arrow-body-style */
import $ from 'jquery';
import { chain, pick, extend, reduce, isUndefined, defaults, result, isNaN, map } from 'underscore';
import headerTemplate from './header.pug';

const defaultMinWidth = 80;
const defaultMaxWidth = 800;

const extendColumns = (columns, extendFunc) => map(columns, (column) => {
  if (column.columns) {
    return defaults({ columns: extendColumns(column.columns, extendFunc) }, extendFunc(column));
  }
  return extendFunc(column);
});

const getStyleAttr = column => (isUndefined(column.width) || column.columns ? {} : {
  style: `width: ${column.width}px`,
});

const extendWidthAttr = column => defaults({
  headAttributes: extend(getStyleAttr(column), column.headAttributes),
  bodyAttributes: extend(getStyleAttr(column), column.bodyAttributes),
  footAttributes: extend(getStyleAttr(column), column.footAttributes),
}, column);

const getPoPWidth = (widthMap, column) =>
  ({
    PopSubColWidth: widthMap[`PopSubCol${column.name}`],
    ComparedWidth: widthMap[`Compared${column.name}`],
    ChangeWidth: widthMap[`${column.name}Change`],
    ChangePercentageWidth: widthMap[`${column.name}ChangePercentage`],
  });

const getColumnWidth = () => {
  const $headers = $('.header .flex-row:first-child .flex-cell');
  return reduce($headers.toArray(), (memo, header) => {
    const $header = $(header);
    const name = $header.data('column');
    const width = $header.outerWidth();
    if (name !== 'selection') {
      // eslint-disable-next-line no-param-reassign
      memo[name] = width;
    }
    return memo;
  }, {});
};

export const projectionGridFlexColumnResize = definePlugin => definePlugin('projectionGridFlexColumnResize', [
  'config',
  'gridView',
], (config, gridView) => {
  const { gridName, preferenceService } = config.plugins.projectionGridFlexColumnResize;
  const preferenceKey = `${gridName}-FlexColumnResizePlugin`;
  let isDown = false;
  let $cell;
  let cellWidth;
  let cellMaxWidth;
  let cellMinWidth;
  let prev;

  const saveColumnWidth = () => {
    const columns = gridView.model.get('columns');
    const widthMap = getColumnWidth();
    const columnWithWidth = extendColumns(columns, (column) => {
      column && column.headAttributes && delete column.headAttributes.style;
      column && column.bodyAttributes && delete column.bodyAttributes.style;
      column && column.footAttributes && delete column.footAttributes.style;
      return defaults({
        ...!isUndefined(widthMap[`PopSubCol${column.name}`]) ?
          getPoPWidth(widthMap, column) : {
            width: widthMap[column.name],
          },
      }, column);
    });

    // Don't save the column width to preference if the width > maxWidth.
    // This is possible if the the column is the last one
    preferenceService.setAtUserLevel({
      Name: preferenceKey,
      Data: { columns: pick(widthMap, v => v <= defaultMaxWidth) },
    });

    gridView.patch({ columns: columnWithWidth });
  };

  const onMouseUp = () => {
    if (isDown) {
      saveColumnWidth();
    }

    isDown = false;
  };

  const onMouseDown = (e) => {
    $cell = $(e.target).closest('.flex-cell');
    cellWidth = $cell.width();
    cellMinWidth = isNaN(parseInt($cell.css('minWidth'), 10)) ? defaultMinWidth : parseInt($cell.css('minWidth'), 10);
    cellMaxWidth = isNaN(parseInt($cell.css('maxWidth'), 10)) ? defaultMaxWidth : parseInt($cell.css('maxWidth'), 10);
    prev = e.clientX;
    isDown = true;
  };

  const onMouseMove = (e) => {
    if (isDown) {
      const delta = e.clientX - prev;
      const dist = cellWidth + delta;
      const name = $cell.data('column');
      if (dist >= cellMinWidth || dist <= cellMaxWidth) {
        $(`.flex-cell[data-column="${name}"]`).width(dist);
      }
    }
  };

  const onMouseDbClick = (e) => {
    $cell = $(e.target).closest('.flex-cell');
    cellMinWidth = isNaN(parseInt($cell.css('minWidth'), 10)) ? defaultMinWidth : parseInt($cell.css('minWidth'), 10);
    const name = $cell.data('column');
    $(`.flex-cell[data-column="${name}"]`).width(cellMinWidth);
    saveColumnWidth();
  };

  const resizeProjection = {
    name: 'resizeProjection',
    handler: function resizeProjection(state) {
      const headRows = state.headRows.map((headRow) => {
        const headRowCells = headRow.cells.map((cell) => {
          const column = state.columnGroup.columnIndex[cell.name];
          if (result(column, 'isResizable') === false) return cell;

          return defaults({
            html: headerTemplate({ val: cell.html }),
            classes: ['resizable-column-header', ...cell.classes],
          }, cell);
        });

        return defaults({ cells: headRowCells }, headRow);
      });

      const events = defaults({
        'mousedown .dragger': onMouseDown,
        'click .dragger': e => e.stopPropagation(),
        'dblclick .dragger': onMouseDbClick,
      }, state.events);

      return defaults({ headRows, events }, state);
    },
  };

  gridView.pipeContentProjections(resizeProjection);

  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);

  // init the grid with width in preference
  gridView.on('willUpdate', () => {
    const res = preferenceService.findByNameAtUserLevel(preferenceKey);
    const columnWidthMap = chain(res).result('Data').result('columns').value();

    if (columnWidthMap) {
      const columns = gridView.model.get('columns');
      const columnWithWidth = extendColumns(columns, (column) => {
        const columnWidth = result(columnWidthMap, column.name);
        if (isUndefined(columnWidth)) return column;
        const widthMap = columnWidthMap;

        return defaults({
          ...!isUndefined(widthMap[`PopSubCol${column.name}`]) ?
            getPoPWidth(widthMap, column) : {
              width: widthMap[column.name],
            },
        }, column);
      });

      const columnWithStyle = extendColumns(columnWithWidth, extendWidthAttr);

      gridView.patch({ columns: columnWithStyle });
    }
  });
});
